import { IScannedItemsList } from "./scanned-items-list";
import { Pallet } from "../../../../front-office/model/pallet";

export class ScannedPalletsList implements IScannedItemsList<"pallet", Pallet> {
    public readonly type = "pallet";
    private readonly _items: Pallet[];

    constructor(items: Pallet[]) {
        this._items = [...items];
    }

    public add(item: Pallet) {
        if (!this._items.find(x => x.code === item.code)) {
            return new ScannedPalletsList([...this._items, item]);
        }

        return this;
    }

    public remove(item: Pallet) {
        if (this._items.find(x => x.code === item.code)) {
            const list = new ScannedPalletsList(this._items.filter(x => x.code !== item.code));

            return list.items.length === 0 ? undefined : list;
        }

        return this;
    }

    get items(): Pallet[] {
        return this._items;
    }
}
